export const retornarDiferentes = (passado,presente) => {
    let verificarMudanca = true;

    if (passado.length === 0 && presente.length> 0) {
        verificarMudanca = true;

        return {
            houveMudanca : verificarMudanca,
            futuro: presente
        };
    }

    if (passado === presente){
        verificarMudanca = false;

        return {
            houveMudanca : verificarMudanca,
            futuro: []
        };
    }

    if (passado.length > presente.length){
        verificarMudanca = false;

        return {
            houveMudanca : verificarMudanca,
            futuro: []
        };
    }

    if (passado.length < presente.length){
        verificarMudanca = true;

        const futuro = presente.filter(presente => !passado.includes(presente));

        return {
            houveMudanca: verificarMudanca,
            futuro
        };
    }

    // return {
    //     houveMudanca : objetosIguais
    // };
};
